// extracted by mini-css-extract-plugin
export var closeButton = "_jh-1";
export var closeX = "_jh-3";
export var container = "_jh-0";
export var image = "_jh-2";